export enum HubType {
  None = 0,
  Store = 1,
  Vendor = 2,
  LastMile = 3
}
